import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiConfig from '../config/ApiConfig';
import axios, { Axios } from 'axios';
import { useNavigate } from 'react-router';
import { store } from '../store/index';

//  adding review
export const addReview = createAsyncThunk(
    'course/addReview',
    async ({ data, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.course.addReview}${data?.courseId}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log('error in adding review', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get all reviews
export const getAllReview = createAsyncThunk(
    'course/getAllReview',
    async (data, { rejectWithValue }) => {
        // console.log('course data id', data);
        try {
            const response = await axios.get(
                `${ApiConfig.course.getAllReview}${data?.data?.courseId}`,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.log('error in get courses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// delete reviews
export const deleteReview = createAsyncThunk(
    'course/deleteReview',
    async ({ data, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.course.deleteReview}${data}`,
                {},
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.log('error in get courses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// edit reviews
export const editReview = createAsyncThunk(
    'course/editReview',
    async ({ data, token }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.course.editReview}${data?.id}`,
                data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.log('error in get courses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

//add to cart
export const addToCart = async (courseId, token, toast) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.addToCart}/${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.result;
    } catch (error) {
        console.log('error in add to cart', error);
        toast.error(error?.response?.data?.error);
    }
};

// add Free Course To MyLearning

export const addFreeCourseToMyLearning = async (courseIds, token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.addFreeCourseToMyLearning}`,
            {
                courseId: courseIds
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        console.log('addFreeCourseToMyLearning', response);
        return response;
    } catch (error) {
        console.log('error in add to cart', error);
        // toast.error(error?.response?.data?.error);
    }
};

//add to cart from wishlist
export const addToCartFromWishlist = async (courseId, token, toast) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.addToCartFromWishlist}/${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.result;
    } catch (error) {
        console.log('error in add to cart from wishlist', error);
        toast.error(error?.response?.data?.error);
    }
};

//remove from cart
export const removeFromCart = async (courseId, token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.removeFromCart}/${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response;
    } catch (error) {
        console.log('error in remove from cart', error);
    }
};

//get courses in cart
export const getCoursesInCart = async (token) => {
    try {
        const response = await axios.get(
            `${ApiConfig.course.getCoursesInCart}`,
            {
                headers: {
                    Authorization: `${token}`
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in getcartCourses', error);
    }
};
// Get wishlist
export const getWishlist = async (token) => {
    try {
        const response = await axios.get(`${ApiConfig.course.getWishlist}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        return response.data;
    } catch (error) {
        console.log('error in get wishlist courses', error);
    }
};

//   add to Wishlist
export const addToWishlist = async (courseId, token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.addToWishlist}${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );

        return response;
    } catch (error) {
        console.log('error in add to Wishlist', error);
    }
};

// Get new on platform courses
export const recentlyAddedCourses = createAsyncThunk(
    'course/recentlyAddedCourses',
    async (page, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.recentlyAddedCourses}?pageNumber=${page}`
            );

            return response.data;
        } catch (error) {
            console.log('error in get courses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// Get top rated courses
export const getTopRatedCourses = createAsyncThunk(
    'course/getTopRatedCourses',
    async (page, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getTopRatedCourses}?pageNumber=${page}`
            );

            return response.data;
        } catch (error) {
            console.log('error getTopRatedCourses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);
// Get Free courses
export const getFreeCourses = createAsyncThunk(
    'course/getFreeCourses',
    async (page, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.course.getAllFreeCourses}?pageNumber=${page}`
            );

            return response.data;
        } catch (error) {
            console.log('error getFreeCourses', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// Get instructors on platform
export const instructorsOnPlatform = createAsyncThunk(
    'course/instructorsOnPlatform',
    async (page, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.instructorsOnPlatform}?pageNumber=${page}`
            );

            return response.data;
        } catch (error) {
            console.log('error instructorsOnPlatform', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// Get recommend Courses of logged in user
export const recommendCourses = createAsyncThunk(
    'course/recommendCourses',
    async ({ id, token, page }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.recommendCourses}${id}?pageNumber=${page}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.log('error instructorsOnPlatform', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get trending categories
export const getTrendingCategoriesOfMostRatedCourse = createAsyncThunk(
    'course/getTrendingCategoriesOfMostRatedCourse',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getTrendingCategoriesOfMostRatedCourse}`
            );

            return response.data;
        } catch (error) {
            console.log('error getTrendingCategoriesOfMostRatedCourse', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// log search selection click
export const logSearchSelection = createAsyncThunk(
    'course/logSearchSelection',
    async ({ subCategory, userId }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${ApiConfig.course.logSearchSelection}`,
                { subCategory, userId }
            );
            return response.data;
        } catch (error) {
            console.log('error logSearchSelection', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get most searched subcategories
export const getMostSearchedSubCategories = createAsyncThunk(
    'course/getMostSearchedSubCategories',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getMostSearchedSubCategories}`
            );
            return response.data;
        } catch (error) {
            console.log('error getMostSearchedSubCategories', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get suggested subcategories
export const getSuggestedSubCategories = createAsyncThunk(
    'course/getSuggestedSubCategories',
    async ({ userId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getSuggestedSubCategories}?userId=${userId}`
            );
            return response.data;
        } catch (error) {
            console.log('error getSuggestedSubCategories', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get trending course banner
export const getTrendingCourseBanner = createAsyncThunk(
    'course/getTrendingCourseBanner',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getTrendingCourseBanner}`
            );
            return response.data;
        } catch (error) {
            console.log('error getTrendingCourseBanner', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get getTopCourses
export const getTopCourses = createAsyncThunk(
    'course/getTopCourses',
    async ({ id, token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getTopCourses}${id}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: token
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.log('error instructorsOnPlatform', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get courses of individual instructor on platform before login
export const coursesOfInstructorInDifferentCategories = createAsyncThunk(
    'course/coursesOfInstructorInDifferentCategories',
    async ({ instructorId, token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.coursesOfInstructorInDifferentCategories}${instructorId}`,
                {
                    headers: {
                        // Authorization: `${token}`,
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.log(
                'error in get coursesOfInstructorInDifferentCategories',
                error
            );
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(error.message);
            }
        }
    }
);

// get courses of individual instructor on platform after login
export const coursesOfInstructorInDifferentCategoriesAfterLogin =
    createAsyncThunk(
        'course/coursesOfInstructorInDifferentCategoriesAfterLogin',
        async ({ instructorId, token }, { rejectWithValue }) => {
            // console.log('in api function', instructorId, token);
            try {
                const response = await axios.get(
                    `${ApiConfig.course.coursesOfInstructorInDifferentCategoriesAfterLogin}${instructorId}`,
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    }
                );
                return response.data;
            } catch (error) {
                console.log(
                    'error in get coursesOfInstructorInDifferentCategoriesAfterLogin',
                    error
                );
                if (error.response && error.response.data.message) {
                    return rejectWithValue(error.response.data.message);
                } else {
                    return rejectWithValue(error.message);
                }
            }
        }
    );

// get major categories before login
export const getCoursesByCategory = createAsyncThunk(
    'course/getCoursesByCategory',
    async ({ categoryId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getCoursesByCategory}${categoryId}`,
                {
                    headers: {
                        // Authorization: `${token}`
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.error('error in getCoursesByCategory', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(
                    'An error occurred while fetching courses.'
                );
            }
        }
    }
);

// get major categories after login
export const getCoursesByCategoryAfterLogin = createAsyncThunk(
    'course/getCoursesByCategoryAfterLogin',
    async ({ categoryId, token }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getCoursesByCategoryAfterLogin}${categoryId}`,
                {
                    headers: {
                        Authorization: `${token}`
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.error('error in getCoursesByCategoryAfterLogin', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(
                    'An error occurred while fetching courses.'
                );
            }
        }
    }
);

// get feedback on individual instructor courses
export const getFeedbackOnInstructorCategories = createAsyncThunk(
    'course/getFeedbackOnInstructorCategories',
    async ({ instructorId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${ApiConfig.course.getFeedbackOnInstructorCategories}${instructorId}`
            );

            return response.data;
        } catch (error) {
            console.error('error in getFeedbackOnInstructorCategories', error);
            if (error.response && error.response.data.message) {
                return rejectWithValue(error.response.data.message);
            } else {
                return rejectWithValue(
                    'An error occurred while fetching courses.'
                );
            }
        }
    }
);

//get individual course details by id before login
export const getIndividualCourse = async (courseId) => {
    try {
        const response = await axios.get(
            `${ApiConfig.course.getIndividualCourse}/${courseId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in get individual course', error);
    }
};

//get individual course details by id after login
export const getIndividualCourseAfterLogin = async (courseId, token) => {
    try {
        const response = await axios.get(
            `${ApiConfig.course.getIndividualCourseAfterLogin}/${courseId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in get individual course', error);
    }
};

//save module progress where user left
export const saveModule = async (token, moduleId, courseId) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.saveModule}`,
            {
                moduleId,
                courseId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response;
    } catch (error) {
        console.log('error in save module', error);
    }
};

//get module to resume the course where user left previously
export const getModuleToResumeCourse = async (token, courseId) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.getModuleToResumeCourse}`,
            {
                courseId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in module to resume course', error);
    }
};

//get completion rate of user
export const completionRate = async (token, courseId) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.completionRate}`,
            {
                courseId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response;
    } catch (error) {
        console.log('error in learner completion rate ', error);
    }
};

//get on going courses of user
export const onGoingCourses = async (token, page, completed) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.onGoingCourses}?pageNumber=${page}&completed=${completed}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data;
    } catch (error) {
        console.log('error in ongoing courses', error);
    }
};

//get completed courses of user with certificate already generated or not
export const onGoingCoursesForCertificate = async (token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.onGoingCoursesForCertificate}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data;
    } catch (error) {
        console.log('error in ongoing courses for certificate', error);
    }
};

//mark module as complete
export const markContentAsComplete = async (
    token,
    moduleId,
    courseId,
    toast,
    contentId
) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.markAsComplete}`,
            {
                moduleId,
                courseId,
                contentId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        toast.success('Marked as completed');
        return response;
    } catch (error) {
        console.log('error in mark as complete', error);
        toast.error("Can't mark as completed");
    }
};

//mark module as incomplete to restart
export const markContentAsInComplete = async (
    token,
    moduleId,
    courseId,
    toast,
    contentId
) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.markAsInComplete}`,
            {
                moduleId,
                courseId,
                contentId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        toast.success('Marked as incomplete');
        return response;
    } catch (error) {
        console.log('error in mark as incomplete', error);
        toast.error("Can't mark as incomplete");
    }
};

//get all the marked modules of a course by a user
export const getMarkedModules = async (courseId, token) => {
    try {
        const response = await axios.get(
            `${ApiConfig.course.getMarkedModules}/${courseId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in get marked modules', error);
    }
};

//search api for the whole platform
export const search = async (query, page) => {
    try {
        const response = await axios.get(
            `${ApiConfig.search.search}=${query}&pageNUmber=${page}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in search', error);
    }
};

//get instructor details in the course details page
export const getInstructorDetails = async (instructorId, token) => {
    try {
        const response = await axios.get(
            `${ApiConfig.instructor.getInstructorDetails}/${instructorId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in instructor details', error);
    }
};

//get all sub categories
export const getAllSubCategories = async () => {
    try {
        const response = await axios.get(
            `${ApiConfig.createCourse.getAllSubCategories}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in get all sub categories', error);
    }
};

//restart the course again
export const restartCourse = async (courseId, token) => {
    try {
        const response = await axios.get(
            `${ApiConfig.course.restartCourse}/${courseId}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response;
    } catch (error) {
        console.log('error in restart course', error);
    }
};

//submit answers to unit assessment
export const postAttemptedQuestion = async (data, token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.postAttemptedQuestion}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log('error in post Attempted Question', error);
    }
};

//submit answers to course assessment
export const postAttemptedFinalAssessment = async (data, token) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.postAttemptedFinalAssessment}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log('error in post Attempted Final Assessment', error);
    }
};

//post the assessment marks of user
export const postAssessmentMarks = async (data, token) => {
    // console.log("data", data, token)
    try {
        const response = await axios.post(
            `${ApiConfig.course.postAssessmentMarks}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log('error in get Assessment Marks', error);
    }
};

//get the final assessment marks of user
export const getFinalAssessmentMarks = async (courseId, token) => {
    // console.log("courseId", courseId, token)
    try {
        const response = await axios.post(
            `${ApiConfig.course.postFinalAssessmentMarks}/${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        // console.log("response", response?.data)
        return response?.data;
    } catch (error) {
        console.log('error in get FinalAssessment Marks', error);
    }
};

//check eligibility to download the certificate based on all the assessments
export const checkEligibilityToDownloadCertificate = async (
    token,
    courseId
) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.checkEligibilityToDownloadCertificate}/${courseId}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log(
            'error in check eligibility to download certificate',
            error
        );
    }
};

//generate the certificate record
export const generateCertificate = async (token, dataUriOrCourseId, courseId, userId) => {
    // Support flexible arguments: generateCertificate(token, courseId) or legacy (token, dataUri, courseId, userId)
    const targetCourseId = courseId || dataUriOrCourseId;
    try {
        const response = await axios.post(
            `${ApiConfig.course.generateCertificate}`,
            {
                courseId: targetCourseId,
                course: targetCourseId
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in generate certificate', error);
    }
};

//update the s3 link for the certificate
export const updateCertificate = async (token, dataUri, certificateId) => {
    const formdata = new FormData();
    formdata.append('dataUri', dataUri);
    try {
        const response = await axios.post(
            `${ApiConfig.course.updateCertificate}/${certificateId}`,
            formdata,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: token
                }
            }
        );
        return response?.data?.data;
    } catch (error) {
        console.log('error in update certificate', error);
    }
};

//verify certificate
export const verifyCertificate = async (serialNumber) => {
    try {
        const response = await axios.post(
            `${ApiConfig.course.verifyCertificate}`,
            {
                serialNumber
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        // console.log('response', response?.data?.data);
        return response?.data?.data;
    } catch (error) {
        console.log('error in verify certificate', error);
    }
};
